import { createApp } from 'vue';
import App from './App.vue';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import axios from "axios";
import router from "../router/router.js";
import PrimeVue from 'primevue/config';
// import 'primevue/resources/themes/aura-light-green/theme.css'
import 'primeicons/primeicons.css'
import Aura from '@primeuix/themes/aura';
import '@/assets/scss/style.min.css'
import '@/assets/css/player.css'
import store from '../src/store/index.js';
import 'vue-plyr/dist/vue-plyr.css'


axios.defaults.baseURL = localStorage.getItem("api_base_url") || "https://api.tarekmath.com/api";
// axios.defaults.baseURL = "http://192.168.1.26:8000/api";

const token = localStorage.getItem("token");
if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
}

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: false,
            cssLayer: false
        }
    }
});
app.use(router);
app.use(store);
app.mount('#app');
